import * as React from 'react';
import * as RX from 'reactxp';

import { colors } from '../../../utils/styles';

// tslint:disable:max-line-length
class SadFace extends React.Component<{style?: {[key: string]: any}, active?: boolean }> {

  constructor(props) {
    super(props);
  }

  public render() {
    const { active, style } = this.props;

    return (
      <svg height={35} width={35} viewBox='0 0 24 24' style={{...style}}>
        <path fill={style && style.color ? style.color : active ? colors.red : colors.primary} d='M18,10l-0.8,0.5c0,0-0.5-0.9-1.7-0.9s-1.7,0.9-1.7,0.9L13,10c0.3-0.7,1.2-2,2.5-2S17.7,9.3,18,10z M11,10
        l-0.8,0.5c0,0-0.5-0.9-1.7-0.9s-1.7,0.9-1.7,0.9L6,10c0.3-0.7,1.2-2,2.5-2S10.7,9.3,11,10z M12,0C5.4,0,0,5.4,0,12s5.4,12,12,12
        s12-5.4,12-12S18.6,0,12,0z M12,22C6.5,22,2,17.5,2,12S6.5,2,12,2s10,4.5,10,10S17.5,22,12,22z'/>
        <path fill={style && style.color ? style.color : active ? colors.red : colors.primary} d='M14.5,17.9c-0.9-0.2-1.7-0.3-2.6-0.3c-0.8,0-1.7,0.1-2.6,0.3c-1.1,0.2-1.9-0.2-2.3-1c-0.9-2.1,1.4-4,4.8-4
        c3.5,0,5.7,1.9,4.8,4C16.4,17.6,15.6,18.1,14.5,17.9z M11.9,15.9c1.6,0,3.1,0.7,3.2,0.3c0.8-2.1-7.2-2.2-6.4,0
        C8.9,16.6,10.3,15.9,11.9,15.9z'/>
      </svg>
    );
  }
}

export default SadFace;



// WEBPACK FOOTER //
// ./src/modules/svgs/sad_face/index.web.tsx